export const WARNING_SEVERITY = {
  DEGRADING: 'degrading',
  INFO: 'info',
};

export const CALCULATION_WARNINGS = {
  FREIGHT_TABLE_NOT_LINKED: 'FREIGHT_TABLE_NOT_LINKED',
  ROUTE_VALIDITY_NOT_FOUND: 'ROUTE_VALIDITY_NOT_FOUND',
  ROUTE_VALIDITY_NOT_APPROVED: 'ROUTE_VALIDITY_NOT_APPROVED',
  ZERO_TRAVEL_TARIFF: 'ZERO_TRAVEL_TARIFF',
  VEHICLE_TYPE_MISMATCH: 'VEHICLE_TYPE_MISMATCH',
  ITINERARY_NOT_FOUND: 'ITINERARY_NOT_FOUND',
  FREIGHT_COST_NOT_FOUND: 'FREIGHT_COST_NOT_FOUND',
  MULTIPLE_FREIGHT_TABLES: 'MULTIPLE_FREIGHT_TABLES',
  TARIFF_TOTAL_MISMATCH: 'TARIFF_TOTAL_MISMATCH',
  MANUAL_EXPENSE_VALUE: 'MANUAL_EXPENSE_VALUE',
};

const SEVERITY_BY_CODE = {
  FREIGHT_TABLE_NOT_LINKED: WARNING_SEVERITY.DEGRADING,
  ROUTE_VALIDITY_NOT_FOUND: WARNING_SEVERITY.DEGRADING,
  ROUTE_VALIDITY_NOT_APPROVED: WARNING_SEVERITY.DEGRADING,
  ZERO_TRAVEL_TARIFF: WARNING_SEVERITY.DEGRADING,
  VEHICLE_TYPE_MISMATCH: WARNING_SEVERITY.DEGRADING,
  ITINERARY_NOT_FOUND: WARNING_SEVERITY.DEGRADING,
  FREIGHT_COST_NOT_FOUND: WARNING_SEVERITY.DEGRADING,
  MULTIPLE_FREIGHT_TABLES: WARNING_SEVERITY.INFO,
  TARIFF_TOTAL_MISMATCH: WARNING_SEVERITY.INFO,
  MANUAL_EXPENSE_VALUE: WARNING_SEVERITY.INFO,
};

export const CARRIER_SCOPE_NOTE =
  'A minuta cobre apenas os trechos da transportadora do trecho principal. ' +
  'O valor total pode ser menor que o frete total da carga.';

export const INCOMPLETE_SHEET_NOTE =
  'Documento incompleto: a transportadora receberá a minuta com as lacunas indicadas acima.';

export function resolveWarningSeverity(code) {
  return SEVERITY_BY_CODE[code] || WARNING_SEVERITY.INFO;
}
